/**
 * Constants for i18n language detection and storage
 */

// LocalStorage keys
export const I18N_LANGUAGE_KEY = 'i18nextLng';
export const I18N_MANUAL_SELECTION_KEY = 'i18nextLng-manual';

// Supported languages
export const SUPPORTED_LANGUAGES = ['es', 'en'] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

// Default language for international users
export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

// Language for Spanish users
export const SPANISH_LANGUAGE: SupportedLanguage = 'es';
